import React from 'react'
import SubHeader from '../general/SubHeader';
import SkillDev from '../assets/skill-dev.JPG';
import SessionImg1 from '../assets/session/1.jpg';
import SessionImg2 from '../assets/session/2.jpg';
import SessionImg3 from '../assets/session/3.jpg';
import SessionImg4 from '../assets/session/4.jpg';
import Donation1 from '../assets/donation1.png';
import { Link } from 'react-router-dom';

const SkillDevelopment = () => {
    return (
        <>
            <SubHeader message="Skill Development" />


            {/* Training section */}
            <section className='my-5'>
                <div className='container'>


                    <div className='row'>

                        <div className='col-lg-7 col-12 my-2'>

                            <img src={SkillDev} className='img-fluid' alt='Skill development' />
                            <div className='skill-dev-area'>
                                <p className='sec-heading'>Welfare of People</p>
                                <hr className='sec-heading-hr my-auto' />

                                <p className='text-muted mt-4'>Anvi Foundation is dedicated to empowering communities through skill development, training, and welfare initiatives. We provide comprehensive training programs that enhance employability and promote self-sufficiency.</p>
                                <p className='text-muted'>Our focus includes vocational skills, Government schemes, and entrepreneurship, aimed at fostering sustainable growth and economic independence. Through these efforts, we work to uplift individuals, improve livelihoods, and contribute to the overall well-being of underprivileged communities. Our Foundation is committed to creating opportunities for all to thrive and build a brighter future.</p>

                            </div>
                        </div>


                        <div className='col-lg-4 col-12 my-2'>
                            <div className='px-4 py-4 bg-body-tertiary'>
                                <p className='sec-heading5'>Training under Schemes</p>
                                <hr />
                                <p className='footer-text'><i class="fa-solid fa-database me-3"></i>Vocabulory Training</p>
                                <p className='footer-text'><i class="fa-solid fa-database me-3"></i>PM Vishwakarma</p>
                                <p className='footer-text'><i class="fa-solid fa-database me-3"></i>PM Kaushal Vikas Yojana</p>
                                <p className='footer-text'><i class="fa-solid fa-database me-3"></i>UP Skill Development Mission</p>
                                <p className='footer-text'><i class="fa-solid fa-database me-3"></i>PM Sankalp Yojana</p>
                                <p className='footer-text'><i class="fa-solid fa-database me-3"></i>National Rural Livelihood Mission</p>
                            </div>

                            <div className='px-4 py-4 bg-body-tertiary mt-4'>
                                <p className='sec-heading5'>Session Images</p>
                                <hr />
                                <div className='row'>

                                    <div className='col-6 my-2'>
                                        <img src={SessionImg1} className='img-fluid' alt='Skill development' />
                                    </div>

                                    <div className='col-6 my-2'>
                                        <img src={SessionImg2} className='img-fluid' alt='Skill development' />
                                    </div>

                                    <div className='col-6 my-2'>
                                        <img src={SessionImg3} className='img-fluid' alt='Skill development' />
                                    </div>

                                    <div className='col-6 my-2'>
                                        <img src={SessionImg4} className='img-fluid' alt='Skill development' />
                                    </div>

                                </div>

                                <Link to='/gallery' className='text-dark text-decoration-none fst-italic'>View More <i className="fa-solid fa-angles-right"></i></Link>

                            </div>
                            {/* photos ends */}
                        </div>
                        {/* right section ends */}

                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* Training section */}


            {/* Details Section */}
            <section className='my-5'>
                <div className='container'>

                    <div className='row'>

                        <div className='col-lg-4 col-md-6 col-12 my-3'>
                            <div className='donation-card' style={{ height: '36em' }}>
                                <div className='donation-img-outer'>
                                    <img src={Donation1} className='donation-img' alt='Donation causes' /></div>

                                <div className='px-4'>
                                    <p className='sec-heading5 my-3'>Vocabulory Training</p>
                                    <hr />
                                    <p className='text-muted'>Providing targeted exercises in word
                                        usage, meaning, pronunciation, and context. It includes learning new words, enhancing
                                        comprehension, and practicing communication skills in both spoken and written forms. This
                                        training aims to: -<br />
                                        ◉ Boost language fluency<br />
                                        ◉ Expand vocabulary, and<br />
                                        ◉ Improve overall language competence.</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-3'>
                            <div className='donation-card' style={{ height: '36em' }}>
                                <div className='donation-img-outer'>
                                    <img src={Donation1} className='donation-img' alt='Donation causes' /></div>

                                <div className='px-4'>
                                    <p className='sec-heading5 my-3'>PM Vishwakarma</p>
                                    <hr />
                                    <p className='text-muted'>This initiative aims at enhancing the skills of traditional artisans and
                                        craftspeople, empowering them with modern techniques and tools. It focuses on providing: -<br />
                                        ◉ Skill development training<br />
                                        ◉ Financial support, and<br />
                                        ◉ Market access to artisans involved in traditional crafts like carpentry, pottery, weaving, and metalwork.</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-3'>
                            <div className='donation-card' style={{ height: '36em' }}>
                                <div className='donation-img-outer'>
                                    <img src={Donation1} className='donation-img' alt='Donation causes' /></div>

                                <div className='px-4'>
                                    <p className='sec-heading5 my-3'>PM Kaushal Vikas Yojana</p>
                                    <hr />
                                    <p className='text-muted'>It aims to encourage aptitude towards employable skills and to increase
                                        working efficiency of probable and existing daily wage earners, by training in high-demand
                                        skills like: -<br />
                                        ◉ Plumbing, electrical work<br />
                                        ◉ beauty and wellness, and<br />
                                        ◉ Soft skills, empowering youth with industry-recognized certifications to enhance employability.</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-3'>
                            <div className='donation-card' style={{ height: '36em' }}>
                                <div className='donation-img-outer'>
                                    <img src={Donation1} className='donation-img' alt='Donation causes' /></div>

                                <div className='px-4'>
                                    <p className='sec-heading5 my-3'>UP Skill Development Mission</p>
                                    <hr />
                                    <p className='text-muted'>The Uttar Pradesh SDM focuses on training youth in
                                        various sectors such as agriculture, healthcare, retail, manufacturing, construction,
                                        information technology, and hospitality. This provides skill
                                        development programs in areas like: -<br />
                                        ◉ Digital literacy<br />
                                        ◉ Technical skills, and<br />
                                        ◉ Entrepreneurship, ensuring better job opportunities</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-3'>
                            <div className='donation-card' style={{ height: '36em' }}>
                                <div className='donation-img-outer'>
                                    <img src={Donation1} className='donation-img' alt='Donation causes' /></div>

                                <div className='px-4'>
                                    <p className='sec-heading5 my-3'>PM Sankalp Yojana</p>
                                    <hr />
                                    <p className='text-muted'>We offer training in areas such as entrepreneurship, soft skills, digital
                                        literacy, and vocational trades. It aims to enhance the employability of youth, particularly in rural
                                        and underserved areas, through programs designed to: -<br />
                                        ◉ Improve skill sets<br />
                                        ◉ Fostering self-reliance, and<br />
                                        ◉ Economic growth</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <div className='donation-card' style={{ height: '36em' }}>
                                <div className='donation-img-outer'>
                                    <img src={Donation1} className='donation-img' alt='Donation causes' /></div>

                                <div className='px-4'>
                                    <p className='sec-heading5 my-3'>National Rural Livelihood Mission</p>
                                    <hr />
                                    <p className='text-muted'>It focuses on skill development in sectors like agriculture, livestock
                                        management, rural entrepreneurship, tailoring, handicrafts, and retail. It aims to empower
                                        rural women and youth through: -<br />
                                        ◉ Capacity-building programs<br />
                                        ◉ Providing training in livelihood skills to improve income generation<br />
                                        ◉ Financial inclusion, and sustainable development in rural areas.</p>
                                </div>
                            </div>
                        </div>


                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* Details Section ends */}


        </>
    )
}

export default SkillDevelopment
